var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsSubmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.72 113.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15864",
    d: "m108.69,47.75V13.98c0-1.67-.64-3.27-1.79-4.47-2.68-2.9-5.54-5.62-8.57-8.16C97.2.47,95.8,0,94.37,0h-60.78c-3.58-.08-6.56,2.7-6.75,6.27v41.33c40.52.16,57.85.16,81.84.16h0Zm-14.77-40.5c0-.53.43-.96.96-.96.24,0,.48.09.65.26l6.24,5.82c.39.36.41.97.05,1.36-.18.19-.44.3-.7.3h-6.24c-.53,0-.96-.43-.96-.96h0s0-5.82,0-5.82Zm5.2,29.55h-57.99c-1.95,0-3.54-1.08-3.54-2.41s1.58-2.41,3.54-2.41h57.99c1.95,0,3.54,1.08,3.54,2.4s-1.58,2.41-3.54,2.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15865",
    d: "m113.15,54.61c-.54-.67-1.35-1.06-2.21-1.06H19.29c-1.24-.03-2.35.75-2.73,1.93l-9.76,48.56v-54.83c0-1.31.28-1.54,1.86-1.54h12v-6.9c.08-.92.85-1.61,1.77-1.61v-5.77c-1.73.02-3.4.61-4.76,1.67-1.31.91-2.13,2.37-2.22,3.96v2.89H6.92c-1.89.04-3.68.88-4.91,2.32-1.25,1.36-1.97,3.13-2.01,4.98v58.05c.04,2.18,1.19,4.18,3.06,5.31.53.71,1.37,1.12,2.25,1.13h91.64c1.24.03,2.35-.75,2.73-1.93l13.99-55.15c.14-.71-.05-1.44-.52-1.99"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsSubmission);
export default __webpack_public_path__ + "static/media/ReportsSubmission.ec0f53a9bb8358f7b24b0ab9ba75ba59.svg";
export { ForwardRef as ReactComponent };